import { ArrowRight } from "lucide-react";

const TIERS = [
  { qty: "10 – 24 shirts", price: "$59", per: "each", badge: null },
  { qty: "25 – 49 shirts", price: "$54", per: "each", badge: "Popular" },
  { qty: "50 – 99 shirts", price: "$49", per: "each", badge: "Best value" },
  { qty: "100+ shirts", price: "Custom", per: "quote", badge: null, custom: true },
];

export default function Pricing() {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="py-24 md:py-32 bg-zinc-950 border-y border-zinc-900 relative"
    >
      <div className="absolute inset-0 tribal-pattern opacity-30 pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <p className="text-xs uppercase tracking-[0.3em] text-gold font-semibold">
            Transparent pricing
          </p>
          <h2 className="mt-3 font-display uppercase text-4xl md:text-6xl tracking-tight leading-[0.95]">
            Bulk Uniform <span className="text-teal-400">Pricing</span>
          </h2>
          <p className="mt-4 text-zinc-400">
            Group-friendly pricing that gets better the bigger your order. All
            prices NZD, GST exclusive. Includes design support &amp; one free
            mockup round.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
          {TIERS.map((t, i) => (
            <div
              key={t.qty}
              data-testid={`price-tier-${i}`}
              className={`relative bg-zinc-900 border ${
                t.custom ? "border-gold/60" : "border-zinc-800"
              } p-7 hover:border-teal-400/60 transition-colors`}
            >
              {t.badge && (
                <span className="absolute -top-3 left-7 bg-gold text-zinc-950 text-[10px] font-bold uppercase tracking-wider px-2 py-1">
                  {t.badge}
                </span>
              )}
              <p className="text-[11px] uppercase tracking-[0.2em] text-zinc-500 font-semibold">
                Quantity
              </p>
              <p className="mt-2 font-display text-xl text-white">{t.qty}</p>

              <div className="mt-6 pt-6 border-t border-zinc-800">
                <p className="text-[11px] uppercase tracking-[0.2em] text-zinc-500 font-semibold">
                  Price
                </p>
                <div className="mt-1 flex items-baseline gap-1">
                  <span className={`font-display text-4xl ${t.custom ? "text-gold" : "text-teal-400"}`}>
                    {t.price === "Custom" ? "" : "From "}
                    {t.price}
                  </span>
                  {!t.custom && <span className="text-zinc-500 text-sm uppercase tracking-wider">{t.per}</span>}
                </div>
                {t.custom && (
                  <p className="mt-1 text-xs uppercase tracking-wider text-zinc-500">
                    {t.per}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>

        <p className="mt-10 text-center text-sm text-zinc-400 max-w-2xl mx-auto">
          <span className="text-gold font-semibold uppercase tracking-wider text-xs">Note</span>{" "}
          · Volume discounts available for larger orders — talk to us about
          conference, festival or multi-village bulk projects (200+ units).
        </p>

        <div className="mt-10 text-center">
          <a
            href="#contact"
            data-testid="pricing-cta"
            className="btn-primary inline-flex items-center gap-2"
          >
            Get an itemised quote
            <ArrowRight size={18} />
          </a>
        </div>
      </div>
    </section>
  );
}
